import { render } from "./Ibutton.vue?vue&type=template&id=1c748cea"
import script from "./Ibutton.vue?vue&type=script&lang=js"
export * from "./Ibutton.vue?vue&type=script&lang=js"
script.render = render

export default script